// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Adaptive org/company logos: square JPEG vs circular/transparent-corner logos */
.alumni_univarsity_logo.logo-shape-pending,
.alumni_profile_college_logo.logo-shape-pending,
.work-block .icon.workex-logo.logo-shape-pending,
.logo-shape-pending,
.alumni_univarsity_logo.logo-shape-square,
.alumni_profile_college_logo.logo-shape-square,
.work-block .icon.workex-logo.logo-shape-square,
.logo-shape-square,
.alumni_univarsity_logo.logo-shape-circle,
.alumni_profile_college_logo.logo-shape-circle,
.work-block .icon.workex-logo.logo-shape-circle,
.logo-shape-circle,
.alumni_univarsity_logo.logo-shape-icon,
.alumni_profile_college_logo.logo-shape-icon,
.work-block .icon.workex-logo.logo-shape-icon,
.logo-shape-icon {
    display: flex !important;
    align-items: center;
    justify-content: center;
    background: #fff !important;
    overflow: hidden;
}

.alumni_univarsity_logo.logo-shape-pending,
.alumni_profile_college_logo.logo-shape-pending,
.work-block .icon.workex-logo.logo-shape-pending,
.logo-shape-pending {
    border-radius: 8px;
    border: 1px solid #e5e5e5;
}

.alumni_univarsity_logo.logo-shape-square,
.alumni_profile_college_logo.logo-shape-square,
.work-block .icon.workex-logo.logo-shape-square,
.logo-shape-square {
    border-radius: 8px !important;
    border: 1px solid #e5e5e5 !important;
    padding: 4px !important;
}

.alumni_univarsity_logo.logo-shape-circle,
.alumni_profile_college_logo.logo-shape-circle,
.work-block .icon.workex-logo.logo-shape-circle,
.logo-shape-circle {
    border-radius: 50% !important;
    border: 1px solid #d2d2d2 !important;
    padding: 4px !important;
}

/* Default placeholders (college_icon, no_img, etc.) — circle frame, no clipping */
.alumni_univarsity_logo.logo-shape-icon,
.alumni_profile_college_logo.logo-shape-icon,
.work-block .icon.workex-logo.logo-shape-icon,
.logo-shape-icon {
    border-radius: 50% !important;
    border: 1px solid #d2d2d2 !important;
    padding: 18px !important;
    box-sizing: border-box !important;
    overflow: hidden;
}

.alumni_univarsity_logo.logo-shape-square img,
.alumni_profile_college_logo.logo-shape-square img,
.work-block .icon.workex-logo.logo-shape-square img,
.logo-shape-square img,
.alumni_univarsity_logo.logo-shape-circle img,
.alumni_profile_college_logo.logo-shape-circle img,
.work-block .icon.workex-logo.logo-shape-circle img,
.logo-shape-circle img,
.alumni_univarsity_logo.logo-shape-icon img,
.alumni_profile_college_logo.logo-shape-icon img,
.work-block .icon.workex-logo.logo-shape-icon img,
.logo-shape-icon img {
    border-radius: 0 !important;
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain !important;
    object-position: center !important;
}

.alumni_univarsity_logo.logo-shape-square img,
.alumni_profile_college_logo.logo-shape-square img,
.work-block .icon.workex-logo.logo-shape-square img,
.logo-shape-square img {
    width: 100% !important;
    height: 100% !important;
}

.alumni_univarsity_logo.logo-shape-circle img,
.alumni_profile_college_logo.logo-shape-circle img,
.work-block .icon.workex-logo.logo-shape-circle img,
.logo-shape-circle img {
    width: auto !important;
    height: auto !important;
}

.alumni_univarsity_logo.logo-shape-icon img,
.alumni_profile_college_logo.logo-shape-icon img,
.work-block .icon.workex-logo.logo-shape-icon img,
.logo-shape-icon img,
.alumni_profile_college_logo img[src*='college_icon'],
.alumni_profile_college_logo img[src*='no_img'],
.alumni_profile_college_logo img[src*='no_university_img'] {
    width: 48% !important;
    height: auto !important;
    max-width: 48% !important;
    max-height: 48% !important;
    margin: 0 !important;
    padding: 0 !important;
}
.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img[src*='briefcase']{
    min-width: 45px !important;
    max-height: 25px !important;
}
.work-block .icon.workex-logo.logo-shape-icon img[src*='briefcase'] {
    min-width: 45px !important;
    max-height: 20px !important;
}
`, "",{"version":3,"sources":["webpack://./src/common/controls/AdaptiveLogo.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;;;;;;;;;;;;;;;;IAgBI,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;;;;IAII,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;;;IAII,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;;;;IAII,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA,kFAAkF;AAClF;;;;IAII,6BAA6B;IAC7B,oCAAoC;IACpC,wBAAwB;IACxB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;;;;;;;;;;;;IAYI,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;;;;IAII,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;;IAII,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;;;;;IAOI,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":["/* Adaptive org/company logos: square JPEG vs circular/transparent-corner logos */\n.alumni_univarsity_logo.logo-shape-pending,\n.alumni_profile_college_logo.logo-shape-pending,\n.work-block .icon.workex-logo.logo-shape-pending,\n.logo-shape-pending,\n.alumni_univarsity_logo.logo-shape-square,\n.alumni_profile_college_logo.logo-shape-square,\n.work-block .icon.workex-logo.logo-shape-square,\n.logo-shape-square,\n.alumni_univarsity_logo.logo-shape-circle,\n.alumni_profile_college_logo.logo-shape-circle,\n.work-block .icon.workex-logo.logo-shape-circle,\n.logo-shape-circle,\n.alumni_univarsity_logo.logo-shape-icon,\n.alumni_profile_college_logo.logo-shape-icon,\n.work-block .icon.workex-logo.logo-shape-icon,\n.logo-shape-icon {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    background: #fff !important;\n    overflow: hidden;\n}\n\n.alumni_univarsity_logo.logo-shape-pending,\n.alumni_profile_college_logo.logo-shape-pending,\n.work-block .icon.workex-logo.logo-shape-pending,\n.logo-shape-pending {\n    border-radius: 8px;\n    border: 1px solid #e5e5e5;\n}\n\n.alumni_univarsity_logo.logo-shape-square,\n.alumni_profile_college_logo.logo-shape-square,\n.work-block .icon.workex-logo.logo-shape-square,\n.logo-shape-square {\n    border-radius: 8px !important;\n    border: 1px solid #e5e5e5 !important;\n    padding: 4px !important;\n}\n\n.alumni_univarsity_logo.logo-shape-circle,\n.alumni_profile_college_logo.logo-shape-circle,\n.work-block .icon.workex-logo.logo-shape-circle,\n.logo-shape-circle {\n    border-radius: 50% !important;\n    border: 1px solid #d2d2d2 !important;\n    padding: 4px !important;\n}\n\n/* Default placeholders (college_icon, no_img, etc.) — circle frame, no clipping */\n.alumni_univarsity_logo.logo-shape-icon,\n.alumni_profile_college_logo.logo-shape-icon,\n.work-block .icon.workex-logo.logo-shape-icon,\n.logo-shape-icon {\n    border-radius: 50% !important;\n    border: 1px solid #d2d2d2 !important;\n    padding: 18px !important;\n    box-sizing: border-box !important;\n    overflow: hidden;\n}\n\n.alumni_univarsity_logo.logo-shape-square img,\n.alumni_profile_college_logo.logo-shape-square img,\n.work-block .icon.workex-logo.logo-shape-square img,\n.logo-shape-square img,\n.alumni_univarsity_logo.logo-shape-circle img,\n.alumni_profile_college_logo.logo-shape-circle img,\n.work-block .icon.workex-logo.logo-shape-circle img,\n.logo-shape-circle img,\n.alumni_univarsity_logo.logo-shape-icon img,\n.alumni_profile_college_logo.logo-shape-icon img,\n.work-block .icon.workex-logo.logo-shape-icon img,\n.logo-shape-icon img {\n    border-radius: 0 !important;\n    max-width: 100% !important;\n    max-height: 100% !important;\n    object-fit: contain !important;\n    object-position: center !important;\n}\n\n.alumni_univarsity_logo.logo-shape-square img,\n.alumni_profile_college_logo.logo-shape-square img,\n.work-block .icon.workex-logo.logo-shape-square img,\n.logo-shape-square img {\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.alumni_univarsity_logo.logo-shape-circle img,\n.alumni_profile_college_logo.logo-shape-circle img,\n.work-block .icon.workex-logo.logo-shape-circle img,\n.logo-shape-circle img {\n    width: auto !important;\n    height: auto !important;\n}\n\n.alumni_univarsity_logo.logo-shape-icon img,\n.alumni_profile_college_logo.logo-shape-icon img,\n.work-block .icon.workex-logo.logo-shape-icon img,\n.logo-shape-icon img,\n.alumni_profile_college_logo img[src*='college_icon'],\n.alumni_profile_college_logo img[src*='no_img'],\n.alumni_profile_college_logo img[src*='no_university_img'] {\n    width: 48% !important;\n    height: auto !important;\n    max-width: 48% !important;\n    max-height: 48% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n.alumni_univarsity_details .alumni_univarsity_details_inner_cover .alumni_univarsity_logo img[src*='briefcase']{\n    min-width: 45px !important;\n    max-height: 25px !important;\n}\n.work-block .icon.workex-logo.logo-shape-icon img[src*='briefcase'] {\n    min-width: 45px !important;\n    max-height: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
